let docappAppWait = document.querySelector(".price-item.price-item--regular .money");
//console.log(docappAppWait != "undefined");
//console.log(docappAppWait != null);
/*
if (typeof docappAppWait != "undefined" && docappAppWait != null) {
  //console.log('debug 0 - start');
  waitForElement(".docapp-volume-discounts-promo-line", 5000).then(function () {
    //console.log('debug 0 - after wait');
    calculateProductDiscounts();
    inputCounterObserver();
  });
}
  */

/*
document.addEventListener("DOMContentLoaded", (event) => {
  if ( document.querySelectorAll(".locked-main-product-login").lenght <= 1){
    document.querySelector(".docapp-app-block").style.display = "none";
  }
  
  const elementStickyCart = document.querySelector("#ybl-addtocart-sticky");
  if (typeof elementStickyCart != "undefined" && elementStickyCart != null) {
    var amb = document.querySelector(".add-minus-btn");
    var apb = document.querySelector(".add-plus-btn");

    amb.addEventListener("click", function () {
      var input = document.getElementById("stickyQuantity");
      input.value = parseInt(input.value) - 1;
    });
    apb.addEventListener("click", function () {
      var input = document.getElementById("stickyQuantity");
      input.value = parseInt(input.value) + 1;
    });

    let orgCartButton = document.querySelector(
      ".product-form__buttons .product-form__submit.button"
    );

    window.onscroll = function () {
      var button = document.getElementById("ybl-addtocart-sticky");

      if (
        document.documentElement.scrollTop > 700 &&
        !isElementInViewport(orgCartButton)
      ) {
        button.style.display = "flex";
      } else {
        button.style.display = "none";
      }
    };

    // Funktion zum Scrollen nach oben
    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  }

  const docappApp = document.querySelector(".docapp-app-block");
  if (typeof docappApp != "undefined" && docappApp != null) {

    //console.log("debug 1");
    
    document
      .querySelector(".product-form__input")
      .addEventListener("click", function (event) {
        //console.log("debug 1 - click");
        setTimeout(function () {
          calculateProductDiscounts();
        }, 1500);
      });
  }

  let discountMiniBoxes = document.querySelectorAll(
    ".docapp-volume-discounts-promo-discount"
  );

  discountMiniBoxes.forEach(function (item) {
    //console.log(item.textContent);
    item.textContent = "- " + item.textContent;
  });
});

// calculate discount on product
function calculateProductDiscounts() {
  const docappApp = document.querySelector(".docapp-app-block");
  if (typeof docappApp != "undefined" && docappApp != null) {
  //console.log('calculateProductDiscounts');
  let finalDiscount = null;
  let discountPercents = document.querySelectorAll(
    "docapp-volume-discounts-promo-required"
  );

   //console.log('debug 2');

  let productPrice = "";
  if (
    document.querySelector(".price__sale .price-item.price-item--sale .money")
  ) {
    // console.log('debug 3 - sale');
    productPrice = document.querySelector(
      ".price__sale .price-item.price-item--sale .money"
    ).textContent;
  } else {
     //console.log('debug 4 - regular');

    productPrice = document.querySelector(
      ".price-item.price-item--regular .money"
    ).textContent;
  }

  productPrice = productPrice.replace(/\s/g, "");
  productPrice = productPrice.substring(0, productPrice.length - 4);
  productPrice = productPrice.replace(/\./g, "");
  productPrice = productPrice.replace(/\,/g, ".");
  productPrice = parseFloat(productPrice).toFixed(2);

  let firstDiscountBox = document.querySelector(
    ".docapp-volume-discounts-promo-line .docapp-volume-discounts-promo-required"
  );
  if (firstDiscountBox.innerHTML != "1") {
    let firstDiscountElement = document.createElement("div");
    firstDiscountElement.classList.add("docapp-volume-discounts-promo-line");
    firstDiscountElement.classList.add("no-discount");
    firstDiscountElement.classList.add("active");
    //firstDiscountElement.innerHTML = "<span class='docapp-volume-discounts-promo-required'>1</span><span class='volumen-discount-price'>"+ productPrice +"0 €</span>";

    firstDiscountElement.innerHTML =
      "<span class='docapp-volume-discounts-promo-required'>1</span><span class='docapp-volume-discounts-promo-discount'>0%</span>";
    document
      .querySelector(".docapp-volume-discounts-promo-container")
      .insertBefore(
        firstDiscountElement,
        document.querySelector(".docapp-volume-discounts-promo-line")
      );
  } else {
    document
      .querySelector(".docapp-volume-discounts-promo-line")
      .classList.add("active");
  }
  let discountboxes = document.querySelectorAll(
    ".docapp-volume-discounts-promo-line"
  );
   //console.log(discountboxes);

  discountboxes.forEach(function (item) {
    let itemPercent = item.querySelector(
      ".docapp-volume-discounts-promo-discount"
    ).textContent;
    let itemCount = item.querySelector(
      ".docapp-volume-discounts-promo-required"
    ).textContent;
    itemPercent = Number.parseFloat(itemPercent.replace(/\%/g, ""));

    let discountPrice = productPrice;
    let discount = null;

    item.classList.add('product-image-'+itemCount);

    if (item.querySelector(".docapp-volume-discounts-promo-discount .money")) {
      let itemEuro = item.querySelector(
        ".docapp-volume-discounts-promo-discount .money"
      ).textContent;
      itemEuro = itemEuro.replace(/\€/g, "");
      itemEuro = itemEuro.replace(/\./g, "");
      itemEuro = Number.parseFloat(itemEuro).toFixed(2);
      discount = itemEuro;
    } else {
      discount = (discountPrice * itemPercent) / 100;
    }

    finalDiscount = productPrice - discount;

    let delement = document.createElement("span");
   let dContent = document.createTextNode(
      itemCount + "x " + 
      new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(finalDiscount)
    );
    delement.classList.add("volumen-discount-price");

    if( item.querySelector("span.volumen-discount-price") ){
      //console.log("true");
 
    }else{
      //console.log("false");
      // add the text node to the newly created div
      delement.appendChild(dContent);
       //console.log(delement);
      // add element to docapp-volume-discounts-promo-line
      item.append(delement);
       //console.log('debug 5');
    }

    item.addEventListener("click", function () {
      document.querySelector("input.quantity__input").value =
        item.querySelector(
          ".docapp-volume-discounts-promo-required"
        ).textContent;
      discountboxes.forEach(function (listItem) {
        listItem.classList.remove("active");
      });
      item.classList.add("active");
    });
  });
  }
}
  */

document.addEventListener("DOMContentLoaded", (event) => {

  if ( document.querySelectorAll(".locked-main-product-login").lenght <= 1){
    document.querySelector(".docapp-app-block").style.display = "none";
  }
  
  const elementStickyCart = document.querySelector("#ybl-addtocart-sticky");
  if (typeof elementStickyCart != "undefined" && elementStickyCart != null) {

    let orgCartButton = document.querySelector(
      ".product-form__buttons .product-form__submit.button"
    );

    window.onscroll = function () {
      var button = document.getElementById("ybl-addtocart-sticky");

      if (
        document.documentElement.scrollTop > 700 &&
        !isElementInViewport(orgCartButton)
      ) {
        button.style.display = "flex";
      } else {
        button.style.display = "none";
      }
    };

    // Funktion zum Scrollen nach oben
    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  }

  /*
  const docappApp = document.querySelector(".docapp-app-block");
  if (typeof docappApp != "undefined" && docappApp != null) {

    //console.log("debug 1");
    
    document
      .querySelector(".product-form__input")
      .addEventListener("click", function (event) {
        //console.log("debug 1 - click");
        setTimeout(function () {
          calculateProductDiscounts();
        }, 1500);
      });
  }

  let discountMiniBoxes = document.querySelectorAll(
    ".docapp-volume-discounts-promo-discount"
  );

  discountMiniBoxes.forEach(function (item) {
    //console.log(item.textContent);
    item.textContent = "- " + item.textContent;
  });
  */
});


// calculate discount on product
function calculateProductDiscounts() {
  const docappApp = document.querySelector(".docapp-app-block");
  if (typeof docappApp != "undefined" && docappApp != null) {
  //console.log('calculateProductDiscounts');
  let finalDiscount = null;
  let discountPercents = document.querySelectorAll(
    "docapp-volume-discounts-promo-required"
  );

   //console.log('debug 2');

  let productPrice = "";
  if (
    document.querySelector(".product__info-wrapper .price__sale .price-item.price-item--sale .money")
  ) {
    // console.log('debug 3 - sale');
    productPrice = document.querySelector(
      ".product__info-wrapper .price__sale .price-item.price-item--sale .money"
    ).textContent;
  } else {
     //console.log('debug 4 - regular');

    productPrice = document.querySelector(
      ".product__info-wrapper .price-item.price-item--regular .money"
    ).textContent;
  }

  productPrice = productPrice.replace(/\s/g, "");
  productPrice = productPrice.substring(0, productPrice.length - 4);
  productPrice = productPrice.replace(/\./g, "");
  productPrice = productPrice.replace(/\,/g, ".");
  productPrice = parseFloat(productPrice).toFixed(2);

  let firstDiscountBox = document.querySelector(
    ".docapp-volume-discounts-promo-line .docapp-volume-discounts-promo-required"
  );
  if (firstDiscountBox.innerHTML != "1") {
    let firstDiscountElement = document.createElement("div");
    firstDiscountElement.classList.add("docapp-volume-discounts-promo-line");
    firstDiscountElement.classList.add("no-discount");
    firstDiscountElement.classList.add("active");
    //firstDiscountElement.innerHTML = "<span class='docapp-volume-discounts-promo-required'>1</span><span class='volumen-discount-price'>"+ productPrice +"0 €</span>";

    firstDiscountElement.innerHTML =
      "<span class='docapp-volume-discounts-promo-required'>1</span><span class='docapp-volume-discounts-promo-discount'>0%</span>";
    document
      .querySelector(".docapp-volume-discounts-promo-container")
      .insertBefore(
        firstDiscountElement,
        document.querySelector(".docapp-volume-discounts-promo-line")
      );
  } else {
    document
      .querySelector(".docapp-volume-discounts-promo-line")
      .classList.add("active");
  }
  let discountboxes = document.querySelectorAll(
    ".docapp-volume-discounts-promo-line"
  );
   //console.log(discountboxes);

  let discountboxesLength = discountboxes.length;

    

  discountboxes.forEach(function (item) {
    let itemPercent = item.querySelector(
      ".docapp-volume-discounts-promo-discount"
    ).textContent;
    let itemCount = item.querySelector(
      ".docapp-volume-discounts-promo-required"
    ).textContent;
    itemPercent = Number.parseFloat(itemPercent.replace(/\%/g, ""));

    let discountPrice = productPrice;
    let discount = null;

    if ( discountboxesLength > 1 ) {
      item.classList.add('product-image-'+itemCount); 
    }else{
      item.classList.add('product-image-single');
    }

    if (item.querySelector(".docapp-volume-discounts-promo-discount .money")) {
      let itemEuro = item.querySelector(
        ".docapp-volume-discounts-promo-discount .money"
      ).textContent;
      itemEuro = itemEuro.replace(/\€/g, "");
      itemEuro = itemEuro.replace(/\./g, "");
      itemEuro = Number.parseFloat(itemEuro).toFixed(2);
      discount = itemEuro;
    } else {
      discount = (discountPrice * itemPercent) / 100;
    }

    finalDiscount = productPrice - discount;

    let delement = document.createElement("span");
    let dContent = document.createTextNode(
      itemCount + "x " + 
      new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(finalDiscount)
    );
    delement.classList.add("volumen-discount-price");

    if( item.querySelector("span.volumen-discount-price") ){
      //console.log("true");
 
    }else{
      //console.log("false");
      // add the text node to the newly created div
      delement.appendChild(dContent);

       //console.log(delement);
      // add element to docapp-volume-discounts-promo-line
      item.append(delement);
       //console.log('debug 5');
    }

    item.addEventListener("click", function () {
      document.querySelector("input.quantity__input").value =
        item.querySelector(
          ".docapp-volume-discounts-promo-required"
        ).textContent;
      discountboxes.forEach(function (listItem) {
        listItem.classList.remove("active");
      });
      item.classList.add("active");
    });
  });
  }
}

function inputCounterObserver() {
  let discountboxes = document.querySelectorAll(
    ".docapp-volume-discounts-promo-line"
  );
  let inputCounterElement = document.querySelector("input.quantity__input");
  inputCounterElement.addEventListener("change", function () {
    let val = this.value;

    discountboxes.forEach(function (listItem, val) {
      // remove active class if input fields value, is not on discount
      if (
        listItem.querySelector(
          ".docapp-volume-discounts-promo-line .docapp-volume-discounts-promo-required"
        ).textContent != val
      ) {
        listItem.classList.remove("active");
      }
      // add active if customer change manual input field to 10
      if (
        listItem.querySelector(
          ".docapp-volume-discounts-promo-line .docapp-volume-discounts-promo-required"
        ).textContent == inputCounterElement.value
      ) {
        listItem.classList.add("active");
      }
    });
  });
}

function waitForElement(querySelector, timeout = 0) {
  const startTime = new Date().getTime();
  return new Promise((resolve, reject) => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      if (document.querySelector(querySelector)) {
        clearInterval(timer);
        resolve();
      } else if (timeout && now - startTime >= timeout) {
        clearInterval(timer);
        reject();
      }
    }, 100);
  });
}


/* nextvital discount app */

  let nvdiscountboxes = document.querySelectorAll(
    ".discounts-promo-line"
  );
  nvdiscountboxes.forEach(function (item) {
    item.addEventListener("click", function () {
      document.querySelector("input.quantity__input").value = item.dataset.amount;
      nvdiscountboxes.forEach(function (listItem) {
        listItem.classList.remove("active");
      });
      item.classList.add("active");
    });
    
  });

  function inputCounterObserverNV() {
  let discountboxes_tmp = document.querySelectorAll(
    ".discounts-promo-line"
  );
  let inputCounterElement = document.querySelector("input.quantity__input");
  inputCounterElement.addEventListener("change", function () {
    let val = this.value;

    discountboxes_tmp.forEach(function (listItem, val) {
      // remove active class if input fields value, is not on discount
      if (
        listItem.querySelector(
          ".discounts-promo-line .discounts-promo-required"
        ).textContent != val
      ) {
        listItem.classList.remove("active");
      }
      // add active if customer change manual input field to 10
      if (
        listItem.querySelector(
          ".discounts-promo-line .discounts-promo-required"
        ).textContent == inputCounterElement.value
      ) {
        listItem.classList.add("active");
      }
    });
  });
}

// button animation: if button is clicked, product will added to warenkorb and "Gute Wahl" appears for 1s 
document.addEventListener('DOMContentLoaded', function() {


  inputCounterObserverNV();

  // set first item as marked
  document.querySelector(".discounts-promo-line").classList.add("active");


  // Überwacht alle Klicks auf Buttons oder Formular-Submit-Events
  document.body.addEventListener('click', function(event) {
    const button = event.target.closest('form[action^="/cart/add"], button[name="add"], .add-to-cart, [data-add-to-cart]');
    
    if (button) {
      let addtocartbtn = button;
      
      if(button.querySelector(".btn.btn-small")) {
        //addtocartbtn = button.querySelector(".btn.btn-small");
        console.log("+++++++++++");
      }else{  
        const originalText = addtocartbtn.textContent.trim();
        
        addtocartbtn.classList.add('good-choice-nextvital');
        addtocartbtn.querySelector('span').textContent = 'Gute Wahl 💚';

        setTimeout(() => {
          addtocartbtn.disabled = false;
          addtocartbtn.querySelector('span').textContent = originalText;
          addtocartbtn.classList.remove('good-choice-nextvital');
        }, 2000);
      }  
    }
  });

  /*
  let product_cards = document.querySelectorAll('.product-grid li.grid__item');
  product_cards.forEach(function (item) {
    console.log('++++++');
    if (item.querySelector('.nextvital-product-discount') != null){
      console.log('count');
    }
  });
  */


});

